import { forwardRef } from 'react'
import { Input as AntInput, InputProps, InputRef } from 'antd'
import cl from 'classnames'
import isString from 'lodash/isString'

import styles from './styles.module.scss'

const Input = forwardRef<InputRef, InputProps & { isNonEditable?: boolean }>(
	({ className, isNonEditable, disabled, placeholder, ...props }, ref) => {
		return (
			<AntInput
				{...props}
				className={cl(styles.basicInput, className, {
					'non-editable': isNonEditable
				})}
				ref={ref}
				autoComplete="off"
				title={isString(props.value) ? props.value.trim() : ''}
				disabled={disabled || isNonEditable}
				{...(isNonEditable ? {} : { placeholder })}
			/>
		)
	}
)

export default Input
